import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { Editor } from "@tinymce/tinymce-react";
import { IoMoonOutline, IoSunnyOutline } from "react-icons/io5";
import { editorConfig } from "~/core/helpers";

export default function RegistrationSuccessMessage({
  message,
  inModal,
  editorProps,
  borderWidth,
}: {
  message: string;
  inModal?: boolean;
  editorProps?: any;
  borderWidth?: number;
}) {
  const { colorMode, toggleColorMode } = useColorMode();
  const bg = useColorModeValue("gray.100", "gray.700");
  const props = inModal
    ? {}
    : {
        borderRadius: "2xl",
        p: "2rem",
        with: "100%",
        backgroundColor: bg,
        borderWidth,
      };
  return editorProps ? (
    <>
      <Box
        {...props}
        backgroundColor={undefined}
        className="wysiwyg-container"
        fontFamily="'Poppins', sans-serif"
        color="descText"
      >
        <Editor
          id="success-message"
          {...editorProps}
          key={"success-message"}
          init={{
            ...editorConfig,
            placeholder:
              "Type here a message to show after user successfully registers. (Optional)",
          }}
        />
      </Box>

      <Flex alignItems={"center"} ml={1} mt={0.5}>
        <Text fontSize={"xs"} opacity={0.5}>
          We recommend testing the colors in both Dark and Light modes.
        </Text>
        <Button variant="ghost" onClick={toggleColorMode} ml={2} size="xs">
          <Icon as={colorMode === "light" ? IoMoonOutline : IoSunnyOutline} />
        </Button>
      </Flex>
    </>
  ) : (
    <Box
      {...props}
      className="wysiwyg-container"
      fontFamily="'Poppins', sans-serif"
      color="descText"
      dangerouslySetInnerHTML={{
        __html: message,
      }}
    />
  );
}
